import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["transactionCode", "bankDetail"]

  connect() {
  }

  toggleTransactionCode(event) {
    const selectedMethod = event.target.value;

    if (selectedMethod === "mobile_money") {
      this.transactionCodeTarget.classList.remove("d-none");
    } else {
      this.transactionCodeTarget.classList.add("d-none");
    }
  }

  toggleBankDetailField(event) {
    const selectedMethod = event.target.value;

    if (selectedMethod === "direct_transfer" || selectedMethod === "cheque") {
      this.bankDetailTarget.classList.remove("d-none");
    } else {
      this.bankDetailTarget.classList.add("d-none");
    }
  }
}
